module.exports = __webpack_public_path__ + "media/images/talent/lp/feature03-ee7ae9282d8a6befd6d3ba1ecd366a52.png";